if (!customElements.get("shop-by-category")) {
  customElements.define(
    "shop-by-category",
    class ShopByCategory extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

        this.onTabClick = this.onTabClick.bind(this);

        this.tabs.forEach((tab) => {
          tab.addEventListener("click", this.onTabClick);
        });
      }

      onTabClick(event) {
        const tab = event.currentTarget;
        const index = Number(tab.dataset.index);

        this.tabs.forEach((t, i) => {
          const selected = i === index;
          t.setAttribute("aria-selected", selected ? "true" : "false");
        });

        this.panels.forEach((panel, i) => {
          if (i === index) {
            panel.removeAttribute("hidden");
          } else {
            panel.setAttribute("hidden", "");
          }
        });
      }
    }
  );
}
